import { IAppState } from "../../../app/appTypes"
import { IPatient } from "../../../features/patient/state/patientTypes"

export const getAllPatients = (state: IAppState): { [id: string]: IPatient } => state.entities.patients?.byId

export const getAllPatientIds = (state: IAppState): string[] => state.entities.patients?.allIds

export const getPatientById = (state: IAppState, ownProps: { patientId: string }): IPatient => state.entities?.patients?.byId[ownProps?.patientId]
